<script>
import MetisMenu from 'metismenujs/dist/metismenujs';
/**
 * Sidenav component
 */
export default {
	data() {
		return {
			menuItems: this.getMenuItems(),
			menuData: null,
			currentUserData: JSON.parse(localStorage.getItem('user')),
		};
	},
	mounted: function () {
		new MetisMenu('#side-menu');
		var links = document.getElementsByClassName('side-nav-link-ref');
		var matchingMenuItem = null;
		const paths = [];

		for (var i = 0; i < links.length; i++) {
			paths.push(links[i]['pathname']);
		}
		var itemIndex = paths.indexOf(window.location.pathname);
		if (itemIndex === -1) {
			const strIndex = window.location.pathname.lastIndexOf('/');
			const item = window.location.pathname.substr(0, strIndex).toString();
			matchingMenuItem = links[paths.indexOf(item)];
		} else {
			matchingMenuItem = links[itemIndex];
		}

		if (matchingMenuItem) {
			matchingMenuItem.classList.add('active');
			var parent = matchingMenuItem.parentElement;

			/**
			 * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
			 * We should come up with non hard coded approach
			 */
			if (parent) {
				parent.classList.add('mm-active');
				const parent2 = parent.parentElement.closest('ul');
				if (parent2 && parent2.id !== 'side-menu') {
					parent2.classList.add('mm-show');

					const parent3 = parent2.parentElement;
					if (parent3) {
						parent3.classList.add('mm-active');
						var childAnchor = parent3.querySelector('.has-arrow');
						var childDropdown = parent3.querySelector('.has-dropdown');
						if (childAnchor) childAnchor.classList.add('mm-active');
						if (childDropdown) childDropdown.classList.add('mm-active');

						const parent4 = parent3.parentElement;
						if (parent4 && parent4.id !== 'side-menu') {
							parent4.classList.add('mm-show');
							const parent5 = parent4.parentElement;
							if (parent5 && parent5.id !== 'side-menu') {
								parent5.classList.add('mm-active');
								const childanchor = parent5.querySelector('.is-parent');
								if (childanchor && parent5.id !== 'side-menu') {
									childanchor.classList.add('mm-active');
								}
							}
						}
					}
				}
			}
		}
	},
	methods: {
		/**
		 * Returns true or false if given menu item has child or not
		 * @param item menuItem
		 */
		hasItems(item) {
			return item.subItems !== undefined ? item.subItems.length > 0 : false;
		},

		isMinneapolis(locationIds = []) {
			const minneapolis = 2;
			return locationIds.indexOf(minneapolis) > -1;
		},

		hasUserRoles(userRoles = [], checkUserRoles = []) {
			let hasUserRoles = false;

			if (!userRoles || userRoles.length == 0 || !checkUserRoles || checkUserRoles.length == 0) {
				return hasUserRoles;
			}

			const userRoleIds = userRoles.map((x) => x.id);
			hasUserRoles = userRoleIds.filter((roleId) => checkUserRoles.includes(roleId)).length > 0;

			return hasUserRoles;
		},

		toggleMenu(event) {
			event.currentTarget.nextElementSibling.classList.toggle('mm-show');
		},
		getMenuItems() {
			let currentUserData = JSON.parse(localStorage.getItem('user'));
			if (!currentUserData) {
				return [];
			}

			let userTypes = Array.from(currentUserData['UserTypes']);
			if (!userTypes || userTypes.length == 0) {
				return [];
			}

			let userLocations = Array.from(currentUserData['locations']);

			// System Defines User Roles/Types
			const ADMIN = 1;
			// const STAFF = 2;
			const HR_COORDINATOR = 5;
			const MVS_COORDINATOR = 6;
			const CLIENT_CARE_MANAGER = 7;
			const VOLUNTEER_LEAD = 8;
			const ASSISTANT = 9;
			const APPROVER = 10;
			// const NO_ROLE = 11;
			const DIRECTOR = 12;

			return [
				{
					id: 1,
					label: 'menuitems.dashboards.text',
					icon: 'bx-home-circle',
					link: '/',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, ASSISTANT, APPROVER, DIRECTOR]),
				},
				{
					id: 2,
					label: 'menuitems.search.text',
					icon: 'bx-search',
					link: '/search',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, MVS_COORDINATOR, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, ASSISTANT, APPROVER]),
				},
				{
					id: 3,
					label: 'menuitems.approvals.text',
					icon: 'bxs-group',
					link: '/approvals',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, APPROVER, DIRECTOR]),
					subItems: [
						{
							id: 15,
							label: 'menuitems.view_all_approvals.text',
							link: '/approvals',
							parentId: 3,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, APPROVER, DIRECTOR]),
						},
						{
							id: 16,
							label: 'menuitems.mytasks.text',
							link: '/approvals/mytasks',
							parentId: 3,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, APPROVER, DIRECTOR]),
						},
					],
				},
				{
					id: 4,
					label: 'menuitems.scheduling.text',
					icon: 'bxs-group',
					link: '/scheduling',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, MVS_COORDINATOR, VOLUNTEER_LEAD]) || (this.hasUserRoles(userTypes, [APPROVER]) && !this.isMinneapolis(userLocations)),
					subItems: [
						{
							id: 17,
							label: 'menuitems.scheduling-listing.text',
							link: '/scheduling',
							parentId: 4,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, MVS_COORDINATOR, VOLUNTEER_LEAD]) || (this.hasUserRoles(userTypes, [APPROVER]) && !this.isMinneapolis(userLocations)),
						},
						{
							id: 18,
							label: 'menuitems.scheduling-calender.text',
							link: '/scheduling-calendar-filter',
							parentId: 4,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, MVS_COORDINATOR, VOLUNTEER_LEAD]) || (this.hasUserRoles(userTypes, [APPROVER]) && !this.isMinneapolis(userLocations)),
						},
					],
				},
				{
					id: 5,
					label: 'menuitems.assignment-approver.text',
					icon: 'bx-calendar-check',
					link: '/assignment-approver',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, MVS_COORDINATOR, VOLUNTEER_LEAD]) || (this.hasUserRoles(userTypes, [APPROVER]) && !this.isMinneapolis(userLocations)),
				},
				{
					id: 6,
					label: 'menuitems.registration-progress.text',
					icon: 'bx-file',
					link: '/registration-progress',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, APPROVER, DIRECTOR]),
					subItems: [
						{
							id: 19,
							label: 'menuitems.registration-progress-complete.text',
							link: '/registration-progress',
							parentId: 6,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, APPROVER, DIRECTOR]),
						},
						{
							id: 20,
							label: 'menuitems.registration-progress-incomplete.text',
							link: '/registration-progress-incomplete',
							parentId: 6,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, APPROVER, DIRECTOR]),
						},
					],
				},
				{
					id: 7,
					label: 'menuitems.resources.text',
					icon: 'bxs-user-detail',
					link: '/resources',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, HR_COORDINATOR, MVS_COORDINATOR, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, ASSISTANT, APPROVER, DIRECTOR]),
				},
				{
					id: 8,
					label: 'menuitems.locations.text',
					icon: 'bxs-map',
					link: '/dashboard-locations',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN]),
				},
				{
					id: 9,
					label: 'menuitems.buildings.text',
					icon: 'bx-buildings',
					link: '/buildings',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN]),
				},
				{
					id: 10,
					label: 'menuitems.users.text',
					icon: 'bxs-group',
					link: '/users',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN]),
				},
				{
					id: 11,
					label: 'menuitems.categories.text',
					icon: 'bxs-news',
					link: '/categories',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN]) || (this.hasUserRoles(userTypes, [APPROVER]) && !this.isMinneapolis(userLocations)),
				},
				{
					id: 12,
					label: 'menuitems.roles.text',
					icon: 'bx-id-card',
					link: '/roles',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, DIRECTOR]) || (this.hasUserRoles(userTypes, [APPROVER]) && !this.isMinneapolis(userLocations)),
				},
				{
					id: 13,
					label: 'menuitems.settings.text',
					icon: 'bx-cog',
					link: '/site-settings',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, MVS_COORDINATOR]),
					subItems: [
						{
							id: 21,
							label: 'menuitems.settings.list.site',
							link: '/site-settings',
							parentId: 13,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN]),
						},
						{
							id: 22,
							label: 'menuitems.settings.list.email-templates',
							link: '/email-templates',
							parentId: 13,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, CLIENT_CARE_MANAGER, VOLUNTEER_LEAD, MVS_COORDINATOR]),
						},
						{
							id: 23,
							label: 'menuitems.settings.list.approval-settings',
							link: '/approval-settings',
							parentId: 13,
							isConditionTrue: this.hasUserRoles(userTypes, [ADMIN]),
						},
					],
				},
				{
					id: 14,
					label: 'menuitems.reports.text',
					icon: 'bx-file',
					link: '/reports',
					isConditionTrue: this.hasUserRoles(userTypes, [ADMIN, MVS_COORDINATOR, APPROVER, DIRECTOR]),
				},
			];
		},
	},
};
</script>

<template>
	<!-- ========== Left Sidebar Start ========== -->

	<!--- Sidemenu -->
	<div id="sidebar-menu">
		<!-- Left Menu Start -->
		<ul id="side-menu" class="metismenu list-unstyled">
			<template v-for="item in menuItems">
				<li class="menu-title" v-if="item.isTitle" :key="item.id">
					{{ $t(item.label) }}
				</li>
				<li v-if="!item.isTitle && !item.isLayout && item.isConditionTrue" :key="item.id">
					<a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent" :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
						<i :class="`bx ${item.icon}`" v-if="item.icon"></i>
						<span>{{ $t(item.label) }}</span>
						<span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
					</a>

					<router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
						<i :class="`bx ${item.icon}`" v-if="item.icon"></i>
						<span>{{ $t(item.label) }}</span>
						<span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">{{ $t(item.badge.text) }}</span>
					</router-link>

					<ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
						<li v-for="(subitem, index) of item.subItems" :key="index">
							<router-link :to="subitem.link" v-if="!hasItems(subitem) && subitem.isConditionTrue" class="side-nav-link-ref">{{ $t(subitem.label) }}</router-link>
							<a v-if="hasItems(subitem) && subitem.isConditionTrue" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{ $t(subitem.label) }}</a>
							<ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
								<li v-for="(subSubitem, index) of subitem.subItems" :key="index">
									<router-link :to="subSubitem.link" class="side-nav-link-ref">{{ $t(subSubitem.label) }}</router-link>
								</li>
							</ul>
						</li>
					</ul>
				</li>
			</template>
		</ul>
	</div>
	<!-- Sidebar -->
</template>
